export default __webpack_public_path__ + "static/media/doctor-with-quote.816e4e7c.svg";